import { get } from "../../shared/providers/apiProvider";
import { CityType } from "../../types/cityType";
import { Food } from "./types/Food";
import { getFoodApiRouteUri } from "./routes";

export const getFoods = async (city: CityType): Promise<Food[]> => {
    const uri = getFoodApiRouteUri(city);
    return await get(uri);
};